import {Route, Routes, useNavigate} from "react-router-dom";
import {ShopWindow} from "./ShopWindow";
import React, {useEffect} from "react";
import {ProductDetail} from "./ProductDetail";
import {Cart} from "./Cart";
import {ProductList} from "./ProductList";
import {ABContainer} from "./_components/ABShop";

export function RoutesShop() {
    return (
        <ABContainer>
            <Routes>
                <Route index element={<ShopWindow/>}/>
                <Route path="/detail/:pid" element={<ProductDetail/>}/>

                <Route path="/products" element={<ProductList/>}/>

                <Route path="/cart" element={<Cart/>}/>

                <Route path="*" element={<NotFound/>}/>
            </Routes>
        </ABContainer>
    )
}

function NotFound() {
    const navigate = useNavigate()

    useEffect(() => {
        setTimeout(() => {
            navigate("/shop")
        }, 3000)
    }, [])

    return <>
        <h1>404 Page not found</h1>
        <div>You will be redirected in 3 sec.</div>
    </>
}